import {
  calculateConvenienceFeeGst,
  calculateEarnPoints,
  ParseInt,
} from "../../Utility/Utility";

export function buildOrderPayload({
  loginV3Data,
  validateLoginTokenData,
  totalPayableAmount,
  onlyCash,
  cashPlusPoints,
  isEarnEnabledForSelectedCard,
  isBurnEnabledForSelectedCard,
  isEarnView,
  earnPoints,
  burnPoints,
  supplierMargin,
  clientCommissionData,
  totalPaid,
  category,
  paymentMode,
  convenienceFee,
  gst,
  updatedData,
  productReducer,
  earnMinDeno,
  burmMinDeno,
  journeyType,
  selectedCardBasedRedemtion,
  showRedemptionFee,
  isRedemptionChecked,
  fingerprint,
}) {
  const safeIdentifierType = (() => {
    const rawIdentifierType = selectedCardBasedRedemtion?.identifiertype;

    if (
      rawIdentifierType === undefined ||
      rawIdentifierType === null ||
      rawIdentifierType === ""
    ) {
      return validateLoginTokenData?.identifierType ?? null;
    }

    try {
      return JSON.parse(rawIdentifierType) ?? validateLoginTokenData?.identifierType ?? null;
    } catch (error) {
      return rawIdentifierType ?? validateLoginTokenData?.identifierType ?? null;
    }
  })();

  const normalizedEarnPoints = Math.max(
    0,
    ParseInt(String(earnPoints ?? 0)) || 0,
  );
  const isEarnViewEnabled = String(isEarnView ?? "").trim() !== "2";
  const shouldEarn =
    onlyCash &&
    isEarnEnabledForSelectedCard &&
    isEarnViewEnabled &&
    normalizedEarnPoints > 0;

  let payload = {
    memberId: loginV3Data?.memberIdentifier,
    amount: totalPayableAmount === 0 ? 0 : totalPayableAmount,
    totalEarn: shouldEarn ? normalizedEarnPoints : 0,
    totalBurn: !onlyCash ? burnPoints : 0,
    totalSupplierMargin: supplierMargin,
    totalClientCommission: clientCommissionData,
    totalAmount: parseFloat(totalPaid.toFixed(2)),
    category,
    supplierCode: "",
    orderStatus: "Pending",
    pointsRedeemStatus:
      !isBurnEnabledForSelectedCard || burnPoints === 0 ? "NA" : "Pending",
    pointsEarnStatus: shouldEarn ? "Pending" : "NA",
    pointReversalStatus: "NA",
    pointEarnReversalStatus: "NA",
    paymentStatus: paymentMode === "Only Points" || totalPayableAmount === 0 ? "NA" : onlyCash || cashPlusPoints ? "Pending" : "NA",
    mobile: loginV3Data?.memberProfile?.mobileNumber,
    email: loginV3Data?.memberProfile?.emailId,
    convenienceFee: parseFloat(convenienceFee) || 0,
    gst: gst || 0,
    amountWithoutGst: parseFloat((totalPaid - convenienceFee - gst).toFixed(2)),
    userPaymentMode: paymentMode,
    customerName: `${loginV3Data?.memberProfile?.firstName || ""} ${
      loginV3Data?.memberProfile?.lastName || ""
    }`.trim(),
    identifier: validateLoginTokenData?.subIdentifier || null,
    identifierType: validateLoginTokenData?.identifierType || null,
    visitorId: fingerprint?.visitorId || null,
    fingerprint: fingerprint ? JSON.stringify({
      timestamp: fingerprint.timestamp,
      deviceInfo: fingerprint.deviceInfo,
      displayInfo: fingerprint.displayInfo,
      userAgent: fingerprint.userAgent,
    }) : null,
    products: (Array.isArray(updatedData) ? updatedData : []).map((item) => ({
        productId: productReducer?.productReducer?.id,
        sku: productReducer?.productReducer?.sku,
        denomination: item.denomination,
        qty: item.quantity,
        customerDis:
          productReducer?.productReducerDisocount?.customerDiscount,
        clientCommission: clientCommissionData,
        supplierMargin,
        earnPoint:
          shouldEarn && earnMinDeno
            ? calculateEarnPoints(
                calculateConvenienceFeeGst(
                  parseFloat(item.total),
                  totalPaid,
                  convenienceFee,
                  gst,
                ),
                totalPaid,
                normalizedEarnPoints,
              )
            : 0,
        burnPoint:
          !onlyCash && isBurnEnabledForSelectedCard
            ? burmMinDeno
              ? calculateEarnPoints(
                  calculateConvenienceFeeGst(
                    parseFloat(item.total),
                    totalPaid,
                    convenienceFee,
                    gst,
                  ),
                  totalPaid,
                  burnPoints,
                )
              : 0
            : 0,
        image: productReducer?.productReducer?.small,
        name: productReducer?.productReducer?.name,
      })),
  };

  if (journeyType === false && !onlyCash) {
    payload = {
      ...payload,
      identifier:
        selectedCardBasedRedemtion?.identifier ||
        validateLoginTokenData?.subIdentifier ||
        null,
      identifierType: safeIdentifierType,
      cardNoFirst6Digit: selectedCardBasedRedemtion?.CardNoFirst6Digit || null,
      cardNoLast4Digit: selectedCardBasedRedemtion?.CardNoLast4Digit || null,
      cardDetailsJson: {
        identifier: selectedCardBasedRedemtion?.identifier,
        status: selectedCardBasedRedemtion?.status,
        identifierType: selectedCardBasedRedemtion?.identifiertype,
        cardType: selectedCardBasedRedemtion?.CardType,
        cardTypeName: selectedCardBasedRedemtion?.CardTypeName,
        cardNoFirst6Digit: selectedCardBasedRedemtion?.CardNoFirst6Digit,
        cardNoLast4Digit: selectedCardBasedRedemtion?.CardNoLast4Digit,
        cardSrNo: selectedCardBasedRedemtion?.CardSrNo,
        network: selectedCardBasedRedemtion?.Network,
        roi:
          selectedCardBasedRedemtion?.roi ??
          selectedCardBasedRedemtion?.Roi ??
          selectedCardBasedRedemtion?.ROI ??
          validateLoginTokenData?.roi ??
          validateLoginTokenData?.Roi ??
          validateLoginTokenData?.ROI,
      },
      consonentCapture: "",
      consonentSelected: false,
    };
  }

  if (showRedemptionFee) {
    payload = {
      ...payload,
      consonentCapture: `${new Date().toString()}`,
      consonentSelected: isRedemptionChecked,
    };
  }

  return payload;
}
